// ***********************************
// Calculator.vue
// ***********************************

// To update: copy over the relevant sections as-is
<template>
  <div id="app">
    <div class="container">
      <b-form>



              <!-- The EC2 Mapping section -->
              <b-card
                no-body
                class="mb-1"
                border-variant="warning"
                header-bg-variant="warning"
                header-text-variant="white"
              >
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-btn
                    block
                    href="#"
                    v-b-toggle.accordionEC2
                    variant="warning"
                  >Re-host to EC2 Mapping Tool (experimental)</b-btn>
                </b-card-header>

                <b-collapse id="accordionEC2" v-model="showCollapseEC2" role="tabpanel">
                  <b-card-body>
                    This section provides an experimental tool to help map your desired vCPU, Memory, and IO Throughput to an EC2 shape and accompanying EBS storage.
                    <br>
                    <br>
                    <div>
                      <b-card title="AWS Mapping to EC2 Summary" bg-variant="warning">
                        <div v-if="selected.length==0">
                          <b-row>
                            <b-col>
                              <b>INSTRUCTIONS:</b> Confirm/adjust the performance requirement inputs, and choose an EC2 shape from the candidate EC2 shape list below...
                            </b-col>
                          </b-row>
                        </div>
                        <div v-if="selected.length>0">
                          <b-row>
                            <b-col>
                              EC2 Shape: {{targetconfig_ec2.shape}}
                              <br>
                              {{targetconfig_ec2.shape_summaryText}}
                            </b-col>
                          </b-row>
                          <br>

                          <b-row>
                            <b-col>
                              {{targetconfig_ec2.ebs_data_summaryText1}}
                              <br>
                              {{targetconfig_ec2.ebs_data_summaryText2}}
                            </b-col>
                          </b-row>
                          <br>
                          <b-row>
                            <b-col>
                              {{targetconfig_ec2.ebs_backup_summaryText1}}
                              <br>
                              {{targetconfig_ec2.ebs_backup_summaryText2}}
                            </b-col>
                          </b-row>
                          <br>
                      

                          <b-row>
                            <b-col>
                              <b>License: {{targetconfig_ec2.license_summaryText}}</b>
                              <br/>
                            </b-col>
                          </b-row>
                          <br>


                          <b-row>
                            <b-col>
                              <b>Summary Estimate: {{targetconfig_ec2.summaryText}}</b>
                              <br>
                            </b-col>
                          </b-row>
                          <b-row v-if="targetconfig_ec2.gp2_warnings!=''">
                            <b-col>
                              <br/>
                              <b-card bg-variant="info" text-variant="white" header="GP2 Bursting Info" class="text-center">
                              <b-card-text>
                              {{targetconfig_ec2.gp2_warnings}}
                              </b-card-text>
                              </b-card>
                            </b-col>
                          </b-row>
                          <b-row v-if="targetconfig_ec2.warnings!=''">
                            <b-col>
                              <br/>
                              <b-card bg-variant="danger" text-variant="white" header="Warning" class="text-center">
                              <b-card-text>
                              {{targetconfig_ec2.warnings}}
                              </b-card-text>
                              </b-card>
                            </b-col>
                          </b-row>
                          <br/>
                          <b-button
                            type="submit"
                            v-b-tooltip.hover
                            title="Save user inputs to the database"
                            block
                            variant="success"
                          >Save Page</b-button>

                          <br>
                        </div>
                      </b-card>
                      <br>
                      <br>

                      <b-card header="Performance Requirement Inputs">
                        <b-form-group label="VPCUs" label-cols="4" label-size="sm">
                          <b-form-input
                            type="number"
                            v-model="ec2.VCPU"
                            class="col-6"
                            size="sm"
                            placeholder="Type to Search"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group label="Memory (GB)" label-cols="4" label-size="sm">
                          <b-form-input
                            type="number"
                            v-model="ec2.Memory"
                            class="col-6"
                            size="sm"
                            placeholder="Type to Search"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group label="Throughput (MB/s)" label-cols="4" label-size="sm">
                          <b-form-input
                            type="number"
                            v-model="ec2.Throughput"
                            class="col-6"
                            size="sm"
                            placeholder="Type to Search"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group label="IOPS" label-cols="4" label-size="sm">
                          <b-form-input
                            type="number"
                            v-model="ebs.IOPS"
                            class="col-6"
                            size="sm"
                            placeholder="Enter desired IOPS"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group label="Disk Space (GB)" label-cols="4" label-size="sm">
                          <b-form-input
                            type="number"
                            v-model="ebs.DiskSpace"
                            class="col-6"
                            size="sm"
                            placeholder="Enter size of database"
                          ></b-form-input>
                        </b-form-group>

                        <b-form-group
                          label="Volume Type of EBS Storage"
                          label-cols="4"
                          label-size="sm"
                        >
                          <b-form-select v-model="ebs.VolumeType" size="sm">
                            <option value disabled>Please select an option</option>
                            <option value="gp2">General Purpose SSD (gp2)</option>
                            <option value="gp3">General Purpose SSD (gp3)</option>
                            <option value="io1">Provisioned IOPS SSD (io1)</option>
                            <option value="io2">Provisioned IOPS SSD (io2)</option>
                          </b-form-select>
                        </b-form-group>

                        <b-form-group
                          label="Backup Approach to estimate"
                          label-cols="4"
                          label-size="sm"
                        >
                          <b-form-select v-model="ebs.BackupType" size="sm">
                            <option value disabled>Please select an option</option>
                            <option value="none">Do not model a backup approach</option>
                            <option value="datasnap">EBS Snapshots of the DATA volumes</option>
                            <option value="fra">EBS-based Flash Recovery Area</option>
                            <option
                              value="frasnap"
                            >EBS-based Flash Recovery Area with Snapshots of FRA</option>
                          </b-form-select>
                        </b-form-group>

                        <b-form-group
                          label="Average Change Rate (MB/s)"
                          label-cols="4"
                          label-size="sm"
                          v-if="ebs.BackupType=='datasnap' || ebs.BackupType=='frasnap'"
                        >
                          <b-form-input
                            type="number"
                            step="0.01"
                            v-model="ebs.Backup"
                            class="col-6"
                            size="sm"
                            placeholder="Enter desired change rate"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group
                          label="Snapshot Retention Days"
                          label-cols="4"
                          label-size="sm"
                          v-if="ebs.BackupType=='datasnap' || ebs.BackupType=='frasnap'"
                        >
                          <b-form-input
                            type="number"
                            step="0.01"
                            v-model="ebs.SnapshotDays"
                            class="col-6"
                            size="sm"
                            placeholder="Days to retain incremental snapshots"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-textarea
                          id="textarea10"
                          v-model="comments.EC2"
                          placeholder="Type your EC2/EBS configuration comments/notes here."
                          :rows="3"
                          size="sm"
                          :max-rows="6"
                        ></b-form-textarea>

                        <br>
                        <b-card header="Candidate EC2 Shape List">
                          Click on your desired EC2 shape to select it. The list of candidate EC2 shapes is filtered based on your performance requirement inputs and ordered by default by increasing cost.
                          <br>
                          <br>

                          <!-- https://bootstrap-vue.js.org/docs/components/table/ -->

                          <b-table
                            :per-page="perPage"
                            :current-page="currentPage"
                            selectable
                            responsive
                            select-mode="single"
                            selectedVariant="success"
                            hover
                            :items="filtered"
                            :fields="fields"
                            :sort-by.sync="sortBy"
                            @row-selected="rowSelected"
                          >
                            <template v-slot:cell(show_details)="row">
                              <b-button
                                size="sm"
                                @click="row.toggleDetails"
                                class="mr-2"
                              >{{ row.detailsShowing ? 'Hide' : 'Show'}} Details</b-button>
                            </template>
                            <template v-slot:row-details="row">
                              <b-card>
                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Name:</b>
                                  </b-col>
                                  <b-col>{{ row.item.Name }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>vCPUs:</b>
                                  </b-col>
                                  <b-col>{{ row.item.vCPU_Details }}</b-col>
                                </b-row>
                                <b-row class="mb-2" v-b-tooltip.hover title="Optimize vCPUs (assuming hyperthreading)">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Optimize vCPU choices:</b>
                                  </b-col>
                                  <b-col>{{ row.item.OptimizeVCPUs }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Processor:</b>
                                  </b-col>
                                  <b-col>{{ row.item.Processor }}</b-col>
                                </b-row>

                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Clockspeed:</b>
                                  </b-col>
                                  <b-col>{{ row.item.Clockspeed }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Instance Storage:</b>
                                  </b-col>
                                  <b-col>{{ row.item.InstanceStorage }}</b-col>
                                </b-row>
                                <b-row class="mb-2" >
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Max Throughput:</b>
                                  </b-col>
                                  <b-col>{{ row.item.Throughput }}</b-col>
                                </b-row>
                                <b-row class="mb-2" v-if="row.item.BaselineThroughput>0" v-b-tooltip.hover title="This instance size uses EBS bursting">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Baseline Throughput:</b>
                                  </b-col>
                                  <b-col>{{ row.item.BaselineThroughput }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Compute Units (ECU):</b>
                                  </b-col>
                                  <b-col>{{ row.item.ECU_Details }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>ECU per vCPU:</b>
                                  </b-col>
                                  <b-col>{{ row.item.ECU_per_vCPU }}</b-col>
                                </b-row>

                                <!-- <b-button size="sm" @click="row.toggleDetails">Hide Details</b-button> -->
                              </b-card>
                            </template>
                          </b-table>
                          <b-pagination
                            :total-rows="filtered.length"
                            :per-page="perPage"
                            v-model="currentPage"
                            class="my-0"
                          />

                          <b-row>
                            <b-col class="mt-3 text-left">
                              EC2 Notes:
                              <br>1. The EC2 data is based on information for the Northern Virginia region as of 12/23/2020. All data should be validated before being used. The Reserved Instance pricing is based on standard 1yr No Upfront pricing.
                              <br>2. The EC2 Compute Unit (ECU) provides the relative measure of the integer processing power of an Amazon EC2 instance. A higher ECU is better.
                              <br>3. ECU/$ is the total ECU divided by the hourly linux on-demand cost (and a higher ECU/$ is better).
                              <br>4. ECU/vCPU/$ is the ECU per vCPU divided by the hourly linux on-demand cost (and a higher ECU/vCPU/$ is better). Looking at the ECU/vCPU/$ metric may be helpful when using the Optimizing CPU feature to run a subset of the total vCPUs for a given instance shape.
                              <br>5. Information about Optimizing CPU (i.e. running a subset of CPU cores for a given instance shape) is described here: https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/instance-optimize-cpu.html
                              <br>6. This page does not currently validate EC2 IOPS instance limits, just the IO Throughput limits.
                              <br>7. This page does not account for data transfer fees, T2/T3 Unlimited mode fees, Support fees, nor discount programs like free tier, etc.
                              <br>
                            </b-col>
                          </b-row>

                          <b-row>
                            <b-col class="mt-3 text-left">
                              EBS Notes:
                              <br>1. The EBS estimate is based on information for the Northern Virginia region as of 12/20/2020. All data should be validated before being used.
                              <br>2. Provisioned IOPS EBS Volumes (io1) are assumed as they are recommended for production databases.
                              <br>3. EBS volumes are elastic. The size can be elastically increased. And the provisioned IOPS value can be changed.
                              <br>4. This page does not try to estimate size or costs of EBS snapshots or other database backup storage.
                              <br>
                            </b-col>
                          </b-row>
                        </b-card>
                      </b-card>
                      <br>
                    </div>
                    <a href="#" class="card-link">Top of Page</a>
                    <b-link href="/" class="card-link">Home Page</b-link>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <!-- end of rehost to ec2 mapping section -->

              <!-- The Replatform to RDS Mapping section -->
              <b-card
                no-body
                class="mb-1"
                border-variant="warning"
                header-bg-variant="warning"
                header-text-variant="white"
              >
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-btn
                    block
                    href="#"
                    v-b-toggle.accordionRDS
                    variant="warning"
                  >Re-platform to RDS-Oracle Mapping Tool (experimental)</b-btn>
                </b-card-header>

                <b-collapse id="accordionRDS" v-model="showCollapseRDS" role="tabpanel">
                  <b-card-body>
                    This section provides an experimental tool to help map your desired vCPU, Memory, and IO Throughput to an RDS shape.
                    <br>
                    <br>This section is under construction.
                    <br>
                    <div>
                      <b-card title="AWS Mapping to RDS-Oracle Summary" bg-variant="warning">
                        <div v-if="rdsSelected.length==0">
                          <b-row>
                            <b-col>
                              <b>INSTRUCTIONS:</b> Confirm/adjust the performance requirement inputs, and choose an RDS shape from the candidate RDS shape list below...
                            </b-col>
                          </b-row>
                        </div>

                        <div v-if="rdsSelected.length>0">
                          <b-row>
                            <b-col>
                              RDS Compute Shape: {{targetconfig_rds.shape}}
                              <br>
                              {{targetconfig_rds.shape_summaryText}}
                            </b-col>
                          </b-row>
                          <br>

                          <b-row>
                            <b-col>
                              {{targetconfig_rds.ebs_data_summaryText1}}
                              <br>
                              {{targetconfig_rds.ebs_data_summaryText2}}
                            </b-col>
                          </b-row>
                          <br>
                          <b-row>
                            <b-col>
                              {{targetconfig_rds.ebs_backup_summaryText1}}
                              <br>
                              {{targetconfig_rds.ebs_backup_summaryText2}}
                            </b-col>
                          </b-row>

                          <br>
                      

                          <b-row>
                            <b-col>
                              <b>License: {{targetconfig_rds.license_summaryText}}</b>
                              <br/>
                            </b-col>
                          </b-row>
                          <br>

                          <b-row>
                            <b-col>
                              <b>Summary Estimate: {{targetconfig_rds.summaryText}}</b>
                              <br>
                            </b-col>
                          </b-row>
                          <b-row v-if="targetconfig_rds.gp2_warnings!=''&& targetconfig_rds.ebs_data_type=='gp2'">
                            <b-col>
                              <br/>
                              <b-card bg-variant="info" text-variant="white" header="GP2 Bursting Info" class="text-center">
                              <b-card-text>
                              {{targetconfig_rds.gp2_warnings}}
                              </b-card-text>
                              </b-card>
                            </b-col>
                          </b-row>
                          <b-row v-if="targetconfig_rds.gp2_warnings!='' && targetconfig_rds.ebs_data_type=='io1'">
                            <b-col>
                              <br/>
                              <b-card bg-variant="info" text-variant="white" header="IO1 Info" class="text-center">
                              <b-card-text>
                              {{targetconfig_rds.gp2_warnings}}
                              </b-card-text>
                              </b-card>
                            </b-col>
                          </b-row>

                          <b-row v-if="targetconfig_rds.warnings!=''">
                            <b-col>
                              <br/>
                              <b-card bg-variant="danger" text-variant="white" header="Warning" class="text-center">
                              <b-card-text>
                              {{targetconfig_rds.warnings}}
                              </b-card-text>
                              </b-card>
                            </b-col>
                          </b-row>

                          <br>
                          <b-button
                            type="submit"
                            v-b-tooltip.hover
                            title="Save user inputs to the database"
                            block
                            variant="success"
                          >Save Page</b-button>
                        </div>
                      </b-card>
                      <br>
                      <br>

                      <b-card header="Performance Requirement Inputs">
                        <b-form-group label="VPCUs" label-cols="4" label-size="sm">
                          <b-form-input
                            type="number"
                            v-model="ec2.VCPU"
                            class="col-6"
                            size="sm"
                            placeholder="Type to Search"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group label="Memory (GB)" label-cols="4" label-size="sm">
                          <b-form-input
                            type="number"
                            v-model="ec2.Memory"
                            class="col-6"
                            size="sm"
                            placeholder="Type to Search"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group label="Throughput (MB/s)" label-cols="4" label-size="sm">
                          <b-form-input
                            type="number"
                            v-model="ec2.Throughput"
                            class="col-6"
                            size="sm"
                            placeholder="Type to Search"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group label="IOPS" label-cols="4" label-size="sm">
                          <b-form-input
                            type="number"
                            v-model="ebs.IOPS"
                            class="col-6"
                            size="sm"
                            placeholder="Enter desired IOPS"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group label="Disk Space (GB)" label-cols="4" label-size="sm">
                          <b-form-input
                            type="number"
                            v-model="ebs.DiskSpace"
                            class="col-6"
                            size="sm"
                            placeholder="Enter size of database"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group label="Average Change Rate (MB/s)" label-cols="4" label-size="sm">
                          <b-form-input
                            type="number"
                            step="0.01"
                            v-model="ebs.Backup"
                            class="col-6"
                            size="sm"
                            placeholder="Enter desired change rate"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group
                          label="Snapshot Retention Days"
                          label-cols="4"
                          label-size="sm"
                        >
                          <b-form-input
                            type="number"
                            step="0.01"
                            v-model="ebs.SnapshotDays"
                            class="col-6"
                            size="sm"
                            placeholder="Days to retain incremental snapshots"
                          ></b-form-input>
                        </b-form-group>

                        <b-form-group
                          label="Volume Type of EBS Storage"
                          label-cols="4"
                          label-size="sm"
                        >
                          <b-form-select v-model="ebs.VolumeType" size="sm">
                            <option value disabled>Please select an option</option>
                            <option value="gp2">General Purpose SSD (gp2)</option>
                            <option value="gp3" disabled>General Purpose SSD (gp3) - Not available for RDS yet</option>
                            <option value="io1">Provisioned IOPS SSD (io1)</option>
                            <option value="io2" disabled>Provisioned IOPS SSD (io2) - Not available for RDS yet</option>
                          </b-form-select>
                        </b-form-group>
                        <b-form-textarea
                          id="textarea10"
                          v-model="comments.RDS"
                          placeholder="Type your RDS-Oracle configuration comments/notes here."
                          :rows="3"
                          :max-rows="6"
                          size="sm"
                        ></b-form-textarea>
                        <br>
                        <b-card header="Candidate RDS Shape List">
                          Click on your desired RDS shape to select it. The list of candidate RDS shapes is filtered based on your performance requirement inputs and ordered by default by increasing cost.
                          <br>
                          <br>

                          <!-- https://bootstrap-vue.js.org/docs/components/table/ -->

                          <b-table
                            :per-page="perPage"
                            :current-page="currentPageRDS"
                            selectable
                            responsive
                            select-mode="single"
                            selectedVariant="success"
                            hover
                            :items="rdsfiltered"
                            :fields="rdsfields"
                            :sort-by.sync="rdssortBy"
                            @row-selected="rdsRowSelected"
                          >
                            <template v-slot:cell(show_details)="row">
                              <b-button
                                size="sm"
                                @click="row.toggleDetails"
                                class="mr-2"
                              >{{ row.detailsShowing ? 'Hide' : 'Show'}} Details</b-button>
                            </template>
                            <template v-slot:row-details="row">
                              <b-card>
                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Name:</b>
                                  </b-col>
                                  <b-col>{{ row.item.Name }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>vCPUs:</b>
                                  </b-col>
                                  <b-col>{{ row.item.vCPU_Details }}</b-col>
                                </b-row>
                                <b-row class="mb-2" v-b-tooltip.hover title="Optimize vCPUs (assuming hyperthreading)">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Optimize vCPU choices:</b>
                                  </b-col>
                                  <b-col>{{ row.item.OptimizeVCPUs }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Processor:</b>
                                  </b-col>
                                  <b-col>{{ row.item.Processor }}</b-col>
                                </b-row>

                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Clockspeed:</b>
                                  </b-col>
                                  <b-col>{{ row.item.Clockspeed }}</b-col>
                                </b-row>
                                <b-row class="mb-2" >
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Max Throughput:</b>
                                  </b-col>
                                  <b-col>{{ row.item.Throughput }}</b-col>
                                </b-row>
                                <b-row class="mb-2" v-if="row.item.BaselineThroughput>0" v-b-tooltip.hover title="This instance size uses EBS bursting">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Baseline Throughput:</b>
                                  </b-col>
                                  <b-col>{{ row.item.BaselineThroughput }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>Compute Units (ECU):</b>
                                  </b-col>
                                  <b-col>{{ row.item.ECU_Details }}</b-col>
                                </b-row>
                                <b-row class="mb-2">
                                  <b-col sm="3" class="text-sm-right">
                                    <b>ECU per vCPU:</b>
                                  </b-col>
                                  <b-col>{{ row.item.ECU_per_vCPU }}</b-col>
                                </b-row>

                                <!-- <b-button size="sm" @click="row.toggleDetails">Hide Details</b-button> -->
                              </b-card>
                            </template>
                          </b-table>
                          <b-pagination
                            :total-rows="rdsfiltered.length"
                            :per-page="perPage"
                            v-model="currentPageRDS"
                            class="my-0"
                          />

                          <b-row>
                            <b-col class="mt-3 text-left">
                              RDS Notes:
                              <br>1. The RDS data is based on information for the Northern Virginia region as of 12/20/2020. Reserved Instance pricing is based on Standard 1 year No Upfront Reserved Instances.
                              <br>2. The EC2 Compute Unit (ECU) provides the relative measure of the integer processing power of an Amazon EC2 instance. A higher ECU is better.
                              <br>3. ECU/$ is the total ECU divided by the hourly Oracle BYOL on-demand cost (and a higher ECU/$ is better).
                              <br>4. ECU/vCPU/$ is the ECU per vCPU divided by the hourly Oracle BYOL on-demand cost (and a higher ECU/vCPU/$ is better). Looking at the ECU/vCPU/$ metric may be helpful when using the Optimizing CPU feature to run a subset of the total vCPUs for a given instance shape.
                              <br>5. Information about Optimizing CPU (i.e. running a subset of CPU cores for a given instance shape) is described here: https://aws.amazon.com/about-aws/whats-new/2018/06/introducing-optimize-cpus-for-amazon-rds-for-oracle/
                              <br>6. For License-Included pricing, you can find details on this page: https://aws.amazon.com/rds/oracle/pricing/
                              <br>7. This page does not currently validate RDS IOPS instance limits, just the IO Throughput limits.
                              <br>8. RDS-Oracle Storage volumes are elastic. The size can be elastically increased. And the provisioned IOPS value can be changed.
                              <br>9. This page does not account for data transfer fees, T2/T3 Unlimited mode fees, Support fees, nor discount programs like free tier, etc.
                              <br>
                            </b-col>
                          </b-row>
                        </b-card>
                      </b-card>
                      <br>
                    </div>
                    <a href="#" class="card-link">Top of Page</a>
                    <b-link href="/" class="card-link">Home Page</b-link>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <!-- End of Replatform to RDS section -->


 
      </b-form>
    </div>
  </div>
</template>

<script>
import { API } from "aws-amplify";
import TimeChartContainer from "./TimeChartContainer.vue";
import TimeChart2Container from "./TimeChart2Container.vue";
import TimeChart4Container from "./TimeChart4Container.vue";
import TimeBarChartNContainer from "./TimeBarChartNContainer.vue";
import axios from "axios";

export default {
  name: "app",
  components: {
    timechartcontainer: TimeChartContainer,
    timechart2container: TimeChart2Container,
    timechart4container: TimeChart4Container,
    timebarchartncontainer: TimeBarChartNContainer
  },
  async created() {
    // console.log("I am here1");
    var tries = 3;
    // now load reviewComments


    // now load EC2 info
    await axios
      .get("/ec2.json")
      .then(response => {
        // console.log(this.ec2);
        this.items = response.data.items;

       
      })
      .catch(error => {
        console.log("Metrics-Load ec2 data Error:", error);
      });
    // console.log("I am here4");

    // now load RDS info
    await axios
      .get("/rds.json")
      .then(response => {
        // console.log("I am here4");
        this.rdsItems = response.data.rdsItems;

        
      })
      .catch(error => {
        console.log("Metrics-Load rds data Error:", error);
      });

    // now load Aurora info
    await axios
      .get("/aurora.json")
      .then(response => {
        // console.log("I am here4");
        this.auroraItems = response.data.auroraItems;

        
      })
      .catch(error => {
        console.log("Metrics-Load aurora data Error:", error);
      });


// console.log("I am here4");
  }, //end created()


  props: ["user"],
  data() {
    return {
      comments: {
        General: "",
        DiskSpace: "",
        CPU: "",
        Memory: "",
        IO: "",
        Backup: "",
        EC2: "",
        RDS: "",
        Waits: "",
        Exadata: "",
        Aurora: ""
      },
      genItems: [{ name: "Retrieving Data..." }],
      showCollapse: true,
      showMax: false,
      showHostCPU: false,
      showCollapseIO: false,
      showCollapseBackup: false,
      showCollapseDiskSpace: false,
      showCollapseCPU: false,
      showCollapseSessions: false,
      showCollapseMemory: false,
      showCollapseExa: false,
      showCollapseEC2: false,
      showCollapseMap: true,
      showCollapseMapOverview: false,
      showCollapseRDS: false,
      showCollapseAurora: false,
      sortBy: "LinuxOD",
      rdssortBy: "OracleOD",
      aurorasortBy: "AuroraPGOD",      
      ec2: {
        VCPU: "",
        Memory: "",
        Throughput: ""
      },
      ec2extras: {
        CPU_src: "",
        CPU_src_specint: "",
        VCPU_adj_other: "",
        ec2_shape: "",
        rds_shape: "",
        aurora_shape: "",
        aurora_flavor: ""
      },
      ebs: {
        DiskSpace: "",
        DiskSpace_src: "",
        DiskSpace_adj_other: "",
        IOPS: "",
        Backup: "",
        VolumeType: "gp2",
        SnapshotDays: "",
        BackupType: "none",
        aurora_IOPS_adj: ""
      },
      selected: [],
      rdsSelected: [],
      auroraSelected: [],
      currentPage: 1,
      perPage: 6,
      currentPageRDS: 1,
      currentPageAurora: 1,      
      fields: [
        {Name: {
          label: "Name",
          sortable: true
        }},
        {VCPU: {
          label: "VCPU",
          sortable: true
        }},
        {Memory: {
          label: "Memory",
          sortable: true
        }},
        {Throughput: {
          label: "Throughput",
          sortable: true
        }},
        {LinuxOD: {
          label: "On-Demand $/hour",
          sortable: true
        }},
        {Linux1yrNURI: {
          label: "1Year Reserved $/hour",
          sortable: true
        }},
        {ECU_per_linuxOD: {
          label: "ECU /$",
          sortable: true
        }},
        {ECU_per_vCPU_per_linuxOD: {
          label: "ECU/vCPU /$",
          sortable: true
        }},
        {show_details: {
          label: "Show Details",
          sortable: false
        }}
      ],
      rdsfields: [
        {Name: {
          label: "Name",
          sortable: true
        }},
        {VCPU: {
          label: "VCPU",
          sortable: true
        }},
        {Memory: {
          label: "Memory",
          sortable: true
        }},
        {Throughput: {
          label: "Throughput",
          sortable: true
        }},
        {OracleOD: {
          label: "On-Demand $/hour",
          sortable: true
        }},
        {Oracle1yrNURI: {
          label: "1Year Reserved $/hour",
          sortable: true
        }},
        {ECU_per_oracleOD: {
          label: "ECU /$",
          sortable: true
        }},
        {ECU_per_vCPU_per_oracleOD: {
          label: "ECU/vCPU /$",
          sortable: true
        }},
        {show_details: {
          label: "Show Details",
          sortable: false
        }}
      ],
      aurorafields: [
        {Name: {
          label: "Name",
          sortable: true
        }},
        {VCPU: {
          label: "VCPU",
          sortable: true
        }},
        {Memory: {
          label: "Memory",
          sortable: true
        }},
        {Throughput: {
          label: "Throughput",
          sortable: true
        }},
        {AuroraPGOD: {
          label: "On-Demand $/hour",
          sortable: true
        }},
        {AuroraPGRI: {
          label: "1Year Reserved $/hour",
          sortable: true
        }},
        {ECU_per_auroraPGOD: {
          label: "ECU /$",
          sortable: true
        }},
        {show_details: {
          label: "Show Details",
          sortable: false
        }}
      ],      
      items: [
        {
          Name: "r4.16xlarge",
          VCPU: 64,
          Memory: 488.0,
          Throughput: 1750.0,
          LinuxOD: 4.256,
          Linux1yrNURI: 2.688,
          Processor: "Intel Xeon E5-2686 v4 (Broadwell)",
          Clockspeed: "2.3 GHz",
          InstanceStorage: "EBS only",
          ECUs: 195.0,
          ECU_per_linuxOD: 45.8,
          vCPU_Details: "64 vCPUs",
          ECU_Details: "195 units",
          ECU_per_vCPU: 3.05,
          ECU_per_vCPU_per_linuxOD: 0.7,
          OptimizeCores: "2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32",
          OptimizeVCPUs: "4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64"
        }
      ],

      rdsItems: [
        {
          Name: "db.r4.16xlarge",
          VCPU: 64,
          Memory: 488.0,
          Throughput: 1750.0,
          OracleOD: 7.68,
          Oracle1yrNURI: 0.0,
          Processor: "Intel Xeon E5-2686 v4 (Broadwell)",
          Clockspeed: "2.3 GHz",
          ECUs: 195.0,
          ECU_per_oracleOD: 25.4,
          vCPU_Details: "64 vCPUs",
          ECU_Details: "195 units",
          ECU_per_vCPU: 3.05,
          ECU_per_vCPU_per_oracleOD: 0.4,
          OptimizeCores: "2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32",
          OptimizeVCPUs: "4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64"
        }
      ],
      auroraItems: [
        {
          Name: "db.r4.16xlarge",
          VCPU: 64,
          Memory: 488.0,
          Throughput: 1750.0,
          AuroraPGOD: 9.28,
          AuroraPGRI: 6.04,
          Processor: "Intel Xeon E5-2686 v4 (Broadwell)",
          Clockspeed: "2.3 GHz",
          ECUs: 195.0,
          ECU_per_auroraPGOD: 21.0,
          vCPU_Details: "64 vCPUs",
          ECU_Details: "195 units"
        }
      ]

    };
  },
  methods: {
    rowSelected(items) {
      this.selected = items;
      if (this.selected.length > 0) {
        this.ec2extras.ec2_shape = this.selected[0].Name;
      } else {
        this.ec2extras.ec2_shape = null;
      }
    },
    rdsRowSelected(items) {
      this.rdsSelected = items;
      if (this.rdsSelected.length > 0) {
        this.ec2extras.rds_shape = this.rdsSelected[0].Name;
      } else {
        this.ec2extras.rds_shape = null;
      }
    },
    auroraRowSelected(items) {
      this.auroraSelected = items;
      if (this.auroraSelected.length > 0) {
        this.ec2extras.aurora_shape = this.auroraSelected[0].Name;
      } else {
        this.ec2extras.aurora_shape = null;
      }
    },
    onReset(evt) {
      evt.preventDefault();

    }
  },
  computed: {
    aurora_calculated_iops() {
       return this.aurora_8k_iops_pre/this.ebs.aurora_IOPS_peak_adj*this.ebs.aurora_IOPS_write_adj;
    },
    aurora_8k_iops_pre() {
      return this.ec2.Throughput*1024/8;
    },
    filtered() {
      const filtered = this.items.filter(item => {
        return Object.keys(this.ec2).every(
          key => item[key] >= this.ec2[key]
          // String(item[key]).includes(this.ec2[key])
        );
      });
      return filtered;
    },
    rdsfiltered() {
      const rdsfiltered = this.rdsItems.filter(item => {
        return Object.keys(this.ec2).every(
          key => item[key] >= this.ec2[key]
          // String(item[key]).includes(this.ec2[key])
        );
      });
      return rdsfiltered;
    },

    aurorafiltered() {
      const aurorafiltered = this.auroraItems.filter(item => ((item.VCPU >= this.ec2.VCPU) && (item.Memory >= this.ec2.Memory)));
      return aurorafiltered;
    },




// **************************
// EC2 Configuration
// **************************
    targetconfig_ec2() {
      var tempConfig = {
        summaryText: "Select an EC2 Shape to continue...",
        monthly_estimate: "null",
        shape: "null",
        shape_OD: "null",
        shape_RI: "null",
        shape_max_vcpu: "null",
        shape_optimize_vcpu: "null",
        requested_vcpu: "null",
        shape_memory: "null",
        requested_memory: "null",
        shape_throughput: "null",
        shape_baselinethroughput: "null",        
        requested_throughput: "null",
        shape_summaryText: "",
        shape_cost: "",
        ebs_data_type: "null",
        ebs_data_size: "null",
        ebs_data_iops: "",
        ebs_data_summaryText1: "",
        ebs_data_summaryText2: "",
        ebs_data_cost: "",
        backup_style: "null",
        ebs_backup_type: "null",
        ebs_backup_size: "null",
        ebs_backup_iops: "",
        ebs_backup_snap_size: "",
        ebs_backup_summaryText1: "",
        ebs_backup_summaryText2: "",
        ebs_backup_cost: "",
        license_summaryText: "",
        comments: "",
        warnings: "",
        gp2_warnings: ""
      };

      if (this.selected.length == 0) {
        return tempConfig;
      }

      // get matching data from items
      // first find what item this is by name
      for (var ii = 0; ii < this.items.length; ii++) {
        if (this.items[ii].Name == this.selected[0].Name) {
          break;
        }
      }
      let selectedItem = this.items[ii];

      // EC2 Section

      tempConfig.shape = selectedItem.Name;
      tempConfig.shape_OD = selectedItem.LinuxOD;
      tempConfig.shape_RI = selectedItem.Linux1yrNURI;
      tempConfig.shape_max_vcpu = selectedItem.VCPU;
      tempConfig.shape_optimize_vcpu = selectedItem.VCPU;
      tempConfig.requested_vcpu = this.ec2.VCPU;
      tempConfig.requested_memory = this.ec2.Memory;
      tempConfig.shape_memory = selectedItem.Memory;
      tempConfig.requested_throughput = this.ec2.Throughput;
      tempConfig.shape_throughput = selectedItem.Throughput;
      tempConfig.shape_baselinethroughput = selectedItem.BaselineThroughput;

      
      tempConfig.ebs_data_type = this.ebs.VolumeType;
      tempConfig.ebs_data_size = this.ebs.DiskSpace;
      tempConfig.backup_style = this.ebs.BackupType;
      tempConfig.ebs_backup_type = "gp2";
      tempConfig.comments = this.comments.EC2;
      if (typeof tempConfig.comments === "undefined") {
        tempConfig.comments = "";
      }

      if (1 * tempConfig.requested_vcpu > 1 * tempConfig.shape_max_vcpu) {
        tempConfig.warnings =
          tempConfig.warnings +
          "The shape " +
          tempConfig.shape +
          " does not have " +
          tempConfig.requested_vcpu +
          " VCPUs. ";
      }
      if (1 * tempConfig.requested_memory > 1 * tempConfig.shape_memory) {
        tempConfig.warnings =
          tempConfig.warnings +
          "The shape " +
          tempConfig.shape +
          " does not have " +
          tempConfig.requested_memory +
          " GB of memory. ";
      }
      if (1 * tempConfig.requested_throughput >
        1 * tempConfig.shape_throughput
      ) {
        tempConfig.warnings =
          tempConfig.warnings +
          "The shape " +
          tempConfig.shape +
          " does not support " +
          tempConfig.requested_throughput +
          " MB/s of IO throughput. ";
      } else {
        if  (1 * tempConfig.shape_baselinethroughput > 0   && (
          1 * tempConfig.requested_throughput >
          1 * tempConfig.shape_baselinethroughput)
        ) 
        {
          tempConfig.warnings =
            tempConfig.warnings +
            "The shape " +
            tempConfig.shape +
            " can burst for short periods to the requested " +
            tempConfig.requested_throughput +
            " MB/s of IO throughput, but has a baseline throughput of " + tempConfig.shape_baselinethroughput + " MB/s. ";
        }
      }  
      

      //optimizeVCPU calculation
      // does this shape offer optimizeVCPU?
      if ((typeof selectedItem.OptimizeVCPUs != "undefined")&&(selectedItem.OptimizeVCPUs != null)) {
        //find the closest match...

        var choices = selectedItem.OptimizeVCPUs.split(",");
        for (var ov = 0; ov < choices.length; ov++) {
          //   console.log("optimizeVCPU debug1:"+tempConfig.requested_vcpu+" "+choices[ov]);
          if (1 * choices[ov] >= tempConfig.requested_vcpu * 1) {
            tempConfig.shape_optimize_vcpu = choices[ov];
            // console.log("Using optimizevcpu"+choices[ov])
            break;
          }
        }
      }

      //licenseText

      tempConfig.license_summaryText =
        "Oracle BYOL for " +
        tempConfig.shape_optimize_vcpu +
        " VCPUs (" +
        0.5 * tempConfig.shape_optimize_vcpu +
        " Oracle Processor Licenses)";

      if (1 * tempConfig.shape_max_vcpu - tempConfig.shape_optimize_vcpu > 0) {
        tempConfig.license_summaryText =
          tempConfig.license_summaryText +
          ".  Optimize CPU feature used to go from " +
          tempConfig.shape_max_vcpu +
          " to " +
          tempConfig.shape_optimize_vcpu +
          " VCPUs.";
      }

      if (1 * tempConfig.shape_optimize_vcpu - tempConfig.requested_vcpu > 4) {
        tempConfig.warnings =
          tempConfig.warnings +
          "This shape does not appear to offer the Optimize CPU feature, meaning you may require more Oracle BYOL licenses than you expect. ";
      }

      tempConfig.shape_summaryText =
        "Monthly estimate (EC2 using 1-year Reserved Instance pricing): $" +
        (selectedItem.Linux1yrNURI * 730).toFixed(2);
      tempConfig.shape_cost=(selectedItem.Linux1yrNURI * 730);

      var tempString = "EC2 Monthly=";
      var tempCost = 0.0;
      if (this.ebs.VolumeType == "io1") {
        // io1
        tempConfig.ebs_data_summaryText1 =
          "EBS Volume Type (DATA): " +
          this.ebs.DiskSpace +
          " GB of io1 (Provisioned IOPS SSD) at " +
          this.ebs.IOPS +
          " IOPS.";

        tempConfig.ebs_data_iops = this.ebs.IOPS;
        tempConfig.ebs_data_cost = (this.ebs.DiskSpace * 0.125) +(0.0625 * this.ebs.IOPS);
        tempConfig.ebs_data_summaryText2 =
          "Monthly estimate (DATA): EBS Volumes=$" +
          (tempConfig.ebs_data_cost).toFixed(2) + " [Storage=$"+
          (this.ebs.DiskSpace * 0.125).toFixed(2) +
          ", IOPS=$" +
          (0.0625 * this.ebs.IOPS).toFixed(2) + "] " ;

        tempString =
          tempString +
          "[" +
          selectedItem.Name +
          "] + EBS(DATA)=[" +
          this.ebs.VolumeType +
          " @ " +
          this.ebs.DiskSpace +
          " GB @ " +
          this.ebs.IOPS +
          " IOPS]";
        tempCost =
          1 * tempCost +
          (selectedItem.Linux1yrNURI * 730 +
            this.ebs.DiskSpace * 0.125 +
            0.0625 * this.ebs.IOPS);
      } else if (this.ebs.VolumeType == "io2") {
        //io2
        tempConfig.ebs_data_summaryText1 =
          "EBS Volume Type (DATA): " +
          this.ebs.DiskSpace +
          " GB of io2 (Provisioned IOPS SSD) at " +
          this.ebs.IOPS +
          " IOPS.";
        var iopsCost=0.0;
        if (this.ebs.IOPS*1<=32000) {
          iopsCost=this.ebs.IOPS*0.065;
        } else {
          iopsCost=32000*0.065;
          if (this.ebs.IOPS*1<=64000) {
            iopsCost=32000*0.065 + (this.ebs.IOPS-32000)*0.046;
          } else {
            iopsCost=32000*0.065 + 32000*0.046 + (this.ebs.IOPS-64000)*0.032;
          }
        }

        tempConfig.ebs_data_iops = this.ebs.IOPS;
        tempConfig.ebs_data_cost = (this.ebs.DiskSpace * 0.125) +iopsCost;

        tempConfig.ebs_data_summaryText2 =
          "Monthly estimate (DATA): EBS Volumes=$" +
          (tempConfig.ebs_data_cost).toFixed(2) + " [Storage=$"+
          (this.ebs.DiskSpace * 0.125).toFixed(2) +
          ", IOPS=$" +
          (iopsCost).toFixed(2) + "] " ;


        tempString =
          tempString +
          "[" +
          selectedItem.Name +
          "] + EBS(DATA)=[" +
          this.ebs.VolumeType +
          " @ " +
          this.ebs.DiskSpace +
          " GB @ " +
          this.ebs.IOPS +
          " IOPS]";
        tempCost =
          1 * tempCost +
          (selectedItem.Linux1yrNURI * 730 +
            tempConfig.ebs_data_cost);

        if (1 * this.ebs.IOPS > 256000) {
          tempConfig.gp2_warnings =
            tempConfig.gp2_warnings +
            "This tool may not compute prices accurately when specifying over 256000 IOPS. ";
        }
        if (1 * this.ebs.IOPS > 500 * this.ebs.DiskSpace) {
          tempConfig.gp2_warnings =
            tempConfig.gp2_warnings +
            "io2 can support up to 500 IOPS per GB, which for your disk storage size would be " +
            this.ebs.DiskSpace * 500 +
            ".  This is less than your desired " +
            this.ebs.IOPS +
            " IOPS. ";
        }
        //other things to check?
        //io2 volume max is 16TB.  io2 block express max is 64TB
        //io2 block express can do 1000 IOPS/GB (more than 500)
        
            
      } else if (this.ebs.VolumeType == "gp3") {
        //gp3
        tempConfig.ebs_data_summaryText1 =
          "EBS Volume Type (DATA): " +
          this.ebs.DiskSpace +
          " GB of gp3 (General Purpose SSD) at " +
          this.ebs.IOPS +
          " IOPS and " +
          tempConfig.requested_throughput +
          " MB/s. ";
        var iopsCost=0.0;
        if (this.ebs.IOPS*1>3000) {
          iopsCost=(this.ebs.IOPS-3000)*0.005;
        } 

        var mbsCost=0.0;
        if (tempConfig.requested_throughput*1>125) {
          mbsCost=(tempConfig.requested_throughput-125)*0.06;
        } 
        
        tempConfig.ebs_data_iops = this.ebs.IOPS;
        tempConfig.ebs_data_cost = (this.ebs.DiskSpace * 0.08) +iopsCost + mbsCost;

        tempConfig.ebs_data_summaryText2 =
          "Monthly estimate (DATA): EBS Volumes=$" +
          (tempConfig.ebs_data_cost).toFixed(2) + " [Storage=$"+
          (this.ebs.DiskSpace * 0.08).toFixed(2) +
          ", IOPS=$" +
          (iopsCost).toFixed(2) +
        ", MB/s=$" +
          (mbsCost).toFixed(2) +"] " ;


        tempString =
          tempString +
          "[" +
          selectedItem.Name +
          "] + EBS(DATA)=[" +
          this.ebs.VolumeType +
          " @ " +
          this.ebs.DiskSpace +
          " GB @ " +
          this.ebs.IOPS +
          " IOPS @ "+
          tempConfig.requested_throughput +
          " MB/s]";
        tempCost =
          1 * tempCost +
          (selectedItem.Linux1yrNURI * 730 +
            tempConfig.ebs_data_cost);

        if (1 * this.ebs.IOPS > 500 * this.ebs.DiskSpace) {
          tempConfig.gp2_warnings =
            tempConfig.gp2_warnings +
            "gp3 can support up to 500 IOPS per GB, which for your disk storage size would be " +
            this.ebs.DiskSpace * 500 +
            ".  This is less than your desired " +
            this.ebs.IOPS +
            " IOPS. ";
        }
        //other things to check?
        
      } else {  
        //gp2
        tempConfig.ebs_data_summaryText1 =
          "EBS Volume Type (DATA): " +
          this.ebs.DiskSpace +
          " GB of gp2 (General Purpose SSD)";
        tempConfig.ebs_data_summaryText2 =
          "Monthly estimate (DATA): EBS Volumes=$" +
          (this.ebs.DiskSpace * 0.1).toFixed(2);

        tempConfig.ebs_data_cost = (this.ebs.DiskSpace * 0.1) ;
  

        if (1 * this.ebs.IOPS > 3 * this.ebs.DiskSpace) {
          tempConfig.gp2_warnings =
            tempConfig.gp2_warnings +
            "Calculated gp2 baseline IOPS of " +
            this.ebs.DiskSpace * 3 +
            " is less than your desired " +
            this.ebs.IOPS +
            " IOPS (please confirm that the gp2 bursting profile fits your workload). ";
        }
        // https://aws.amazon.com/blogs/database/understanding-burst-vs-baseline-performance-with-amazon-rds-and-gp2/

        tempString =
          tempString +
          "[" +
          selectedItem.Name +
          "] + EBS(DATA)=[" +
          this.ebs.VolumeType +
          " @ " +
          this.ebs.DiskSpace +
          " GB]";
        tempCost =
          1 * tempCost +
          (selectedItem.Linux1yrNURI * 730 + this.ebs.DiskSpace * 0.1);
      }

      //backup style
      var snapshotSize = 0;
      if (
        this.ebs.BackupType == "datasnap" ||
        this.ebs.BackupType == "frasnap"
      ) {
        // assume 0.7 for database backup compression: skip null blocks
        snapshotSize =
          ((this.ebs.Backup * 60 * 60 * 24) / 1024) * this.ebs.SnapshotDays +
          this.ebs.DiskSpace * 0.7;
      }

      if (this.ebs.BackupType == "fra") {
        tempConfig.ebs_backup_size = 1.25 * this.ebs.DiskSpace;
        tempConfig.ebs_backup_cost=tempConfig.ebs_backup_size * 0.1;
        tempCost = tempCost + tempConfig.ebs_backup_cost;
        

        tempConfig.ebs_backup_summaryText1 =
          "EBS Volume Type (Flash Recovery Area): " +
          tempConfig.ebs_backup_size +
          " GB of gp2 (General Purpose SSD)";
        tempConfig.ebs_backup_summaryText2 =
          "Monthly estimate (FRA): EBS Volumes=$" + tempConfig.ebs_backup_cost.toFixed(2);
        
        tempString =
          tempString +
          " + EBS(FRA)=[gp2 @ " +
          this.ebs.DiskSpace * 1.25 +
          " GB]";
      }
      if (this.ebs.BackupType == "datasnap") {
        tempConfig.ebs_backup_snap_size = snapshotSize;
        tempConfig.ebs_backup_cost=0.05 * snapshotSize;
        tempCost = tempCost + tempConfig.ebs_backup_cost;

        tempConfig.ebs_backup_summaryText1 =
          "EBS Snapshots (DATA): estimated " +
          tempConfig.ebs_backup_snap_size.toFixed(0) +
          " GB of Snapshots";
        tempConfig.ebs_backup_summaryText2 =
          "Monthly estimate (Snapshots of DATA): EBS Snapshots=$" +
          tempConfig.ebs_backup_cost.toFixed(2);
        

        tempString =
          tempString +
          " + Snapshots(DATA)=[" +
          snapshotSize.toFixed(0) +
          " GBs of Snapshots]";
      }
      if (this.ebs.BackupType == "frasnap") {
        tempConfig.ebs_backup_size = 1.25 * this.ebs.DiskSpace;
        tempConfig.ebs_backup_snap_size = snapshotSize;
        tempCost =
          tempCost + 1.25 * this.ebs.DiskSpace * 0.1 + 0.05 * snapshotSize;

        tempConfig.ebs_backup_summaryText1 =
          "EBS Volume Type (Flash Recovery Area): " +
          tempConfig.ebs_backup_size +
          " GB of gp2 (General Purpose SSD) with estimated " +
          tempConfig.ebs_backup_snap_size.toFixed(0) +
          " GB of Snapshots";
        tempConfig.ebs_backup_summaryText2 =
          "Monthly estimate (FRA): EBS Volumes=$" +
          (tempConfig.ebs_backup_size * 0.1).toFixed(2) +
          ", EBS Snapshots=$" +
          (0.05 * tempConfig.ebs_backup_snap_size).toFixed(2);

        tempConfig.ebs_backup_cost=1.25 * this.ebs.DiskSpace * 0.1 + 0.05 * snapshotSize;

        tempString =
          tempString +
          " + EBS(FRA)=[gp2 @ " +
          this.ebs.DiskSpace * 1.25 +
          " GB with " +
          snapshotSize.toFixed(0) +
          " GBs of Snapshots]";
      }
      tempConfig.summaryText =
        tempString +
        "=$" +
        tempCost.toFixed(2) +
        " + " +
        0.5 * tempConfig.shape_optimize_vcpu +
        " Oracle Processor Licenses + Self Management";

      tempConfig.monthly_estimate   = Math.round(tempCost*100)/100;

      return tempConfig;
    },




// **************************
// RDS Configuration
// **************************
    targetconfig_rds() {
      var tempConfig = {
        summaryText: "Select a RDS Shape to continue...",
        monthly_estimate: "null",
        shape: "null",
        shape_OD: "null",
        shape_RI: "null",
        shape_max_vcpu: "null",
        shape_optimize_vcpu: "null",
        requested_vcpu: "null",
        shape_memory: "null",
        requested_memory: "null",
        shape_throughput: "null",
        requested_throughput: "null",
        shape_baselinethroughput: "null",    
        shape_summaryText: "",
        shape_cost: "",
        ebs_data_type: "null",
        ebs_data_size: "null",
        ebs_data_iops: "",
        ebs_data_summaryText1: "",
        ebs_data_summaryText2: "",
        ebs_data_cost: "",
        // "backup_style" : "null",
        // "ebs_backup_type" : "null",
        // "ebs_backup_size" : "null",
        // "ebs_backup_iops" : "",
        ebs_backup_snap_size: "",
        ebs_backup_summaryText1: "",
        ebs_backup_summaryText2: "",
        ebs_backup_cost: "",
        license_summaryText: "",
        comments: "",
        warnings: "",
        gp2_warnings: ""
      };

      if (this.rdsSelected.length == 0) {
        return tempConfig;
      }

      // get matching data from items
      // first find what item this is by name
      for (var ii = 0; ii < this.rdsItems.length; ii++) {
        if (this.rdsItems[ii].Name == this.rdsSelected[0].Name) {
          break;
        }
      }
      let selectedItem = this.rdsItems[ii];

      tempConfig.shape = selectedItem.Name;
      tempConfig.shape_OD = selectedItem.OracleOD;
      tempConfig.shape_RI = selectedItem.Oracle1yrNURI;
      tempConfig.shape_max_vcpu = selectedItem.VCPU;
      tempConfig.shape_optimize_vcpu = selectedItem.VCPU;
      tempConfig.requested_vcpu = this.ec2.VCPU;
      tempConfig.requested_memory = this.ec2.Memory;
      tempConfig.shape_memory = selectedItem.Memory;
      tempConfig.requested_throughput = this.ec2.Throughput;
      tempConfig.shape_throughput = selectedItem.Throughput;
      tempConfig.shape_baselinethroughput = selectedItem.BaselineThroughput;
      tempConfig.ebs_data_type = this.ebs.VolumeType;
      tempConfig.ebs_data_size = this.ebs.DiskSpace;
      tempConfig.comments = this.comments.RDS;
      if (typeof tempConfig.comments === "undefined") {
        tempConfig.comments = "";
      }

      if (1 * tempConfig.requested_vcpu > 1 * tempConfig.shape_max_vcpu) {
        tempConfig.warnings =
          tempConfig.warnings +
          "The shape " +
          tempConfig.shape +
          " does not have " +
          tempConfig.requested_vcpu +
          " VCPUs. ";
      }
      if (1 * tempConfig.requested_memory > 1 * tempConfig.shape_memory) {
        tempConfig.warnings =
          tempConfig.warnings +
          "The shape " +
          tempConfig.shape +
          " does not have " +
          tempConfig.requested_memory +
          " GB of memory. ";
      }
      if (
        1 * tempConfig.requested_throughput >
        1 * tempConfig.shape_throughput
      ) {
        tempConfig.warnings =
          tempConfig.warnings +
          "The shape " +
          tempConfig.shape +
          " does not support " +
          tempConfig.requested_throughput +
          " MB/s of IO throughput. ";
      } else {
        if  (1 * tempConfig.shape_baselinethroughput > 0   && (
          1 * tempConfig.requested_throughput >
          1 * tempConfig.shape_baselinethroughput)
        ) 
        {
          tempConfig.warnings =
            tempConfig.warnings +
            "The shape " +
            tempConfig.shape +
            " can burst for short periods to the requested " +
            tempConfig.requested_throughput +
            " MB/s of IO throughput, but has a baseline throughput of " + tempConfig.shape_baselinethroughput + " MB/s. ";
        }
      }  

      //optimizeVCPU calculation
      // does this shape offer optimizeVCPU?
if ((typeof selectedItem.OptimizeVCPUs != "undefined")&&(selectedItem.OptimizeVCPUs != null)) {      
        //find the closest match...
        var choices = selectedItem.OptimizeVCPUs.split(",");
        for (var ov = 0; ov < choices.length; ov++) {
          if (1 * choices[ov] >= tempConfig.requested_vcpu) {
            tempConfig.shape_optimize_vcpu = choices[ov];
            // console.log("Using optimizevcpu"+choices[ov])
            break;
          }
        }
      }

      //licenseText

      tempConfig.license_summaryText =
        "Oracle BYOL for " +
        tempConfig.shape_optimize_vcpu +
        " VCPUs (" +
        0.5 * tempConfig.shape_optimize_vcpu +
        " Oracle Processor Licenses)";

      if (1 * tempConfig.shape_max_vcpu - tempConfig.shape_optimize_vcpu > 0) {
        tempConfig.license_summaryText =
          tempConfig.license_summaryText +
          ".  Optimize CPU feature used to go from " +
          tempConfig.shape_max_vcpu +
          " to " +
          tempConfig.shape_optimize_vcpu +
          " VCPUs.";
      }

      if (1 * tempConfig.shape_optimize_vcpu - tempConfig.requested_vcpu > 4) {
        tempConfig.warnings =
          tempConfig.warnings +
          "This shape does not appear to offer the Optimize CPU feature, meaning you may require more Oracle BYOL licenses than you expect. ";
      }

      var shapeCost = 0;
      if (tempConfig.shape_RI > 0) {
        shapeCost = selectedItem.Oracle1yrNURI * 730;
        tempConfig.shape_summaryText =
          "RDS Compute Monthly estimate (using 1-year Reserved Instance pricing): $" +
          shapeCost.toFixed(2);
      } else {
        shapeCost = selectedItem.OracleOD * 730;

        tempConfig.shape_summaryText =
          "RDS Compute Monthly estimate (using On-Demand pricing): $" +
          shapeCost.toFixed(2);
      }
      tempConfig.shape_cost = shapeCost;

      var rdsSnapshotSize =
        ((this.ebs.Backup * 60 * 60 * 24) / 1024) * this.ebs.SnapshotDays +
        this.ebs.DiskSpace * 0.7;
      // assume some factor (0.7?) for initial backup because RDS says most customers don't need backup space with RDS, so it must be less than 1.0.  Maybe accounts for allocated but unused blocks
      tempConfig.ebs_backup_snap_size = Math.max(0, 1 * rdsSnapshotSize - this.ebs.DiskSpace).toFixed(0);

      // RDS Section
      var tempCost=0.0;
      if ((this.ebs.VolumeType == "io1") || (this.ebs.VolumeType == "io2") ) {
        tempConfig.ebs_data_summaryText1 =
          "RDS Storage: " +
          this.ebs.DiskSpace +
          " GB of io1 (Provisioned IOPS SSD) at " +
          this.ebs.IOPS +
          " IOPS.";
        tempConfig.ebs_data_summaryText2 =
          "Monthly estimate: RDS Storage: EBS Volumes=$" +
          (this.ebs.DiskSpace * 0.125).toFixed(2) +
          ", EBS IOPS=$" +
          (0.1 * this.ebs.IOPS).toFixed(2);

        tempConfig.ebs_data_iops = this.ebs.IOPS;

        if (this.ebs.VolumeType == "io2") {
          tempConfig.warnings =
            tempConfig.warnings + "io2 storage is not yet supported for RDS.  Calculations will use io1 storage. ";
        }

        if (1 * this.ebs.IOPS < 1000) {
          tempConfig.warnings =
            tempConfig.warnings + "io1 IOPS must be at least 1000. ";
        }
        if (1 * this.ebs.IOPS > 80000)  {
          tempConfig.warnings =
            tempConfig.warnings + "io1 IOPS must be less than 80000. ";
        }
        /* if ((1 * this.ebs.IOPS > 40000) && !(
           (tempConfig.shape=='db.m5.24xlarge')||
           (tempConfig.shape=='db.r5.24xlarge')||
           (tempConfig.shape=='db.x1.32xlarge')||
           (tempConfig.shape=='db.x1e.32xlarge')
        )) {
          tempConfig.warnings =
            tempConfig.warnings + "io1 IOPS must be less than 40000 with this shape. ";
        } */
        if (1 * this.ebs.IOPS < 0.5*this.ebs.DiskSpace) {
          tempConfig.warnings =
            tempConfig.warnings + "io1 IOPS must be at least 1/2 the Disk Space in GB. ";
        }
        if (1 * this.ebs.IOPS < 1*this.ebs.DiskSpace) {
          tempConfig.gp2_warnings =
            tempConfig.gp2_warnings + "io1 IOPS are suggested to be at least same as the Disk Space in GB. ";
        }

         if (1 * this.ebs.DiskSpace < 100) {
          tempConfig.warnings =
            tempConfig.warnings + "io1 Disk Size must be at least 100 GB. ";
        }
        if (1 * this.ebs.DiskSpace > 64000) {
          tempConfig.warnings =
            tempConfig.warnings + "io1 Disk Size must be less than 64 TB. ";
        }

        tempConfig.ebs_data_cost = this.ebs.DiskSpace * 0.125 +
            0.1 * this.ebs.IOPS;
        tempConfig.ebs_backup_cost =
            Math.max(0, 0.095 * (1 * rdsSnapshotSize - this.ebs.DiskSpace));

        tempCost=(
            shapeCost +
            this.ebs.DiskSpace * 0.125 +
            0.1 * this.ebs.IOPS +
            Math.max(0, 0.095 * (1 * rdsSnapshotSize - this.ebs.DiskSpace))
          );

        tempConfig.summaryText =
          "RDS-Oracle(BYOL) Monthly=[" +
          selectedItem.Name +
          "] + [io1 @ " +
          this.ebs.DiskSpace +
          " GB @ " +
          this.ebs.IOPS +
          " IOPS] + [additional " +
          Math.max(0, 1 * rdsSnapshotSize - this.ebs.DiskSpace).toFixed(0) +
          " GBs of Snapshots]=$" +
          tempCost.toFixed(2)+
          " + " +
          0.5 * tempConfig.shape_optimize_vcpu +
          " Oracle Processor Licenses";
      } else {  
        //gp2
        tempConfig.ebs_data_summaryText1 =
          "RDS Storage: " +
          this.ebs.DiskSpace +
          " GB of gp2 (General Purpose SSD)";
        tempConfig.ebs_data_summaryText2 =
          "Monthly estimate: RDS Storage: EBS Volumes=$" +
          (this.ebs.DiskSpace * 0.115).toFixed(2);

        // https://aws.amazon.com/blogs/database/understanding-burst-vs-baseline-performance-with-amazon-rds-and-gp2/
        if (this.ebs.VolumeType == "gp3") {
          tempConfig.warnings =
            tempConfig.warnings + "gp3 storage is not yet supported for RDS.  Calculations will use gp2 storage. ";
        }

        if (1 * this.ebs.IOPS > Math.min(this.ebs.DiskSpace * 3, 16000)) {
          tempConfig.gp2_warnings =
            tempConfig.gp2_warnings +
            "Calculated gp2 baseline IOPS of " +
            Math.min(this.ebs.DiskSpace * 3, 16000) +
            " is less than your desired " +
            this.ebs.IOPS +
            " IOPS (please confirm that the gp2 bursting profile fits your workload). ";
        }
        /* if (1 * this.ebs.IOPS > 64000) {
          tempConfig.warnings =
            tempConfig.warnings + "gp2 IOPS must be less than 64000. ";
        } */
        if (1 * tempConfig.requested_throughput > 1000) {
          //single gp2 volume can do 250MB/s.  RDS-Oracle appears to use 4 EBS volumes.
          tempConfig.warnings =
            tempConfig.warnings + "gp2 for RDS-Oracle will not be able to exceed 1000 MB/s.  You should use io1 for this environment. ";
        }
        if (1 * this.ebs.DiskSpace < 20) {
          tempConfig.warnings =
            tempConfig.warnings + "gp2 Disk Size must be at least 20 GB. ";
        }
        if (1 * this.ebs.DiskSpace > 64000) {
          tempConfig.warnings =
            tempConfig.warnings + "gp2 Disk Size must be less than 64 TB. ";
        }

        tempCost=(
            shapeCost +
            this.ebs.DiskSpace * 0.115 +
            Math.max(0, 0.095 * (1 * rdsSnapshotSize - this.ebs.DiskSpace))
          );
        tempConfig.ebs_backup_cost =  Math.max(0, 0.095 * (1 * rdsSnapshotSize - this.ebs.DiskSpace));
        tempConfig.ebs_data_cost = this.ebs.DiskSpace * 0.115;

        tempConfig.summaryText =
          "RDS-Oracle(BYOL) Monthly=[" +
          selectedItem.Name +
          "] + [gp2 @ " +
          this.ebs.DiskSpace +
          " GB] + [additional " +
          Math.max(0, 1 * rdsSnapshotSize - this.ebs.DiskSpace).toFixed(0) +
          " GBs of Snapshots]=$" +
          tempCost.toFixed(2) +
          " + " +
          0.5 * tempConfig.shape_optimize_vcpu +
          " Oracle Processor Licenses";
      }

      tempConfig.ebs_backup_summaryText1 =
        "RDS Backup: First " +
        this.ebs.DiskSpace +
        " GB of backup storage is included (Free backup for up to 100% of provisioned storage).  Estimated size of snapshots is " +
        rdsSnapshotSize.toFixed(0) +
        " GB.";
      tempConfig.ebs_backup_summaryText2 =
        "Monthly estimate: RDS Backup (Additional " +
        Math.max(0, 1 * rdsSnapshotSize - this.ebs.DiskSpace).toFixed(0) +
        " GB)=$" +
        Math.max(0, 0.095 * (1 * rdsSnapshotSize - this.ebs.DiskSpace)).toFixed(
          2
        );

      tempConfig.monthly_estimate=Math.round(tempCost*100)/100;

      return tempConfig;
    },



// **************************
// Aurora Configuration
// **************************
    targetconfig_aurora() {
      var tempConfig = {
        summaryText: "Select an Aurora Shape to continue...",
        monthly_estimate: "null",
        shape: "null",
        shape_OD: "null",
        shape_RI: "null",
        shape_max_vcpu: "null",
        shape_optimize_vcpu: "null",
        requested_vcpu: "null",
        shape_memory: "null",
        requested_memory: "null",
        shape_throughput: "null",
        requested_throughput: "null",
        shape_summaryText: "",
        shape_cost: "",
        ebs_data_type: "null",
        ebs_data_size: "null",
        ebs_data_iops: "",
        ebs_data_summaryText1: "",
        ebs_data_summaryText2: "",
        ebs_data_cost: "",
        // "backup_style" : "null",
        // "ebs_backup_type" : "null",
        // "ebs_backup_size" : "null",
        // "ebs_backup_iops" : "",
        ebs_backup_snap_size: "",
        ebs_backup_summaryText1: "",
        ebs_backup_summaryText2: "",
        ebs_backup_cost: "",
        iops_summaryText1: "",
        iops_summaryText2: "",
        license_summaryText: "",
        comments: "",
        warnings: ""
      };

      if (this.auroraSelected.length == 0) {
        return tempConfig;
      }

      // get matching data from items
      // first find what item this is by name
      for (var ii = 0; ii < this.auroraItems.length; ii++) {
        if (this.auroraItems[ii].Name == this.auroraSelected[0].Name) {
          break;
        }
      }
      let selectedItem = this.auroraItems[ii];

      tempConfig.shape = selectedItem.Name;
      tempConfig.shape_OD = selectedItem.AuroraPGOD;
      tempConfig.shape_RI = selectedItem.AuroraPGRI;
      tempConfig.shape_max_vcpu = selectedItem.VCPU;
      tempConfig.shape_optimize_vcpu = selectedItem.VCPU;
      tempConfig.requested_vcpu = this.ec2.VCPU;
      tempConfig.requested_memory = this.ec2.Memory;
      tempConfig.shape_memory = selectedItem.Memory;
      tempConfig.requested_throughput = this.ec2.Throughput;
      tempConfig.shape_throughput = selectedItem.Throughput;
      tempConfig.ebs_data_type = this.ebs.VolumeType;
      tempConfig.ebs_data_size = this.ebs.DiskSpace;
      tempConfig.comments = this.comments.Aurora;
      if (typeof tempConfig.comments === "undefined") {
        tempConfig.comments = "";
      }

      if (1 * tempConfig.requested_vcpu > 1 * tempConfig.shape_max_vcpu) {
        tempConfig.warnings =
          tempConfig.warnings +
          "The shape " +
          tempConfig.shape +
          " does not have " +
          tempConfig.requested_vcpu +
          " VCPUs. ";
      }
      if (1 * tempConfig.requested_memory > 1 * tempConfig.shape_memory) {
        tempConfig.warnings =
          tempConfig.warnings +
          "The shape " +
          tempConfig.shape +
          " does not have " +
          tempConfig.requested_memory +
          " GB of memory. ";
      }
      // if (
      //   1 * tempConfig.requested_throughput >
      //   1 * tempConfig.shape_throughput
      // ) {
      //   tempConfig.warnings =
      //     tempConfig.warnings +
      //     "The shape " +
      //     tempConfig.shape +
      //     " does not support " +
      //     tempConfig.requested_throughput +
      //     " MB/s of IO throughput. ";
      // }

      var shapeCost = 0;
      if (tempConfig.shape_RI > 0) {
        shapeCost = tempConfig.shape_RI * 732;
        tempConfig.shape_summaryText =
          "Aurora Compute Monthly estimate (using 1-year Reserved Instance pricing for Aurora PostgreSQL): $" +
          shapeCost.toFixed(2);
      } else {
        shapeCost = tempConfig.shape_OD * 732;

        tempConfig.shape_summaryText =
          "Aurora Compute Monthly estimate (using On-Demand pricing for Aurora PostgreSQL): $" +
          shapeCost.toFixed(2);
      }
      tempConfig.shape_cost = shapeCost;

      var auroraSnapshotSize =
        ((this.ebs.Backup * 60 * 60 * 24) / 1024) * this.ebs.SnapshotDays +
        this.ebs.DiskSpace * 0.7;
      // assume some factor (0.7?) for initial backup because RDS says most customers don't need backup space with RDS, so it must be less than 1.0.  Maybe accounts for allocated but unused blocks

      tempConfig.ebs_data_summaryText1 =
        "Aurora Storage: " + this.ebs.DiskSpace + " GB";
      tempConfig.ebs_data_summaryText2 =
        "Aurora Storage Monthly estimate: $" +
        (this.ebs.DiskSpace * 0.1).toFixed(2);

      if (1 * this.ebs.DiskSpace > 64000) {
        tempConfig.warnings =
          tempConfig.warnings + "Aurora Disk Size must be less than 64 TB. ";
      }

      var monthly_iops = this.aurora_calculated_iops * 60 * 732;
      tempConfig.iops_summaryText1 =
        "Aurora IOPS: " +
        (monthly_iops / 1000000).toFixed(2) +
        " million IO requests per month (based on " +
        this.aurora_calculated_iops +
        " requests per second)";
      tempConfig.iops_summaryText2 =
        "Aurora IOPS Monthly Estimate: $" +
        ((monthly_iops / 1000000) * 0.2).toFixed(2);
      tempConfig.ebs_data_iops = this.aurora_calculated_iops*60*732;  

      var tempCost = shapeCost +
          this.ebs.DiskSpace * 0.1 +
          Math.max(0, 0.021 * (1 * auroraSnapshotSize - this.ebs.DiskSpace)) +
          (monthly_iops / 1000000) * 0.2;
      tempConfig.ebs_backup_cost =  Math.max(0, 0.021 * (1 * auroraSnapshotSize - this.ebs.DiskSpace));
      tempConfig.ebs_data_cost = this.ebs.DiskSpace * 0.1 + (monthly_iops / 1000000) * 0.2;

      tempConfig.summaryText =
        "Aurora-PostgreSQL Monthly=[" +
        selectedItem.Name +
        "] + [Aurora Storage @ " +
        this.ebs.DiskSpace +
        " GB] + " +
        " [Aurora IOPS @ " +
        (monthly_iops / 1000000).toFixed(2) +
        " million request/month] " +
        "+ [additional " +
        Math.max(0, 1 * auroraSnapshotSize - this.ebs.DiskSpace).toFixed(0) +
        " GBs of Snapshots]=$" +
        (tempCost).toFixed(2);

      tempConfig.ebs_backup_summaryText1 =
        "Aurora Backup: First " +
        this.ebs.DiskSpace +
        " GB of backup storage is included (Free backup for up to 100% of provisioned storage).  Estimated size of snapshots is " +
        auroraSnapshotSize.toFixed(0) +
        " GB.";
      tempConfig.ebs_backup_summaryText2 =
        "Aurora Backup Monthly estimate (Additional " +
        Math.max(0, 1 * auroraSnapshotSize - this.ebs.DiskSpace).toFixed(0) +
        " GB): $" +
        Math.max(
          0,
          0.021 * (1 * auroraSnapshotSize - this.ebs.DiskSpace)
        ).toFixed(2);
      tempConfig.ebs_backup_snap_size = 1 * auroraSnapshotSize - this.ebs.DiskSpace;
      tempConfig.monthly_estimate=Math.round(tempCost*100)/100;

      return tempConfig;
    } //end of aurora section


  }
};
</script>

<style>
</style>
